import { TFunction } from 'i18next'
import { StringSchema } from 'yup'

import { stringSchema } from '@/Shared/ui/form/validations'
import { formTranslation } from '@/Shared/ui/sharedTranslation'

export const phoneSchema = (
  t: TFunction<'translation', undefined>,
): StringSchema<string | undefined> =>
  stringSchema(t)
    .test('must-comply-format', t(formTranslation.errors.phoneInvalid), value => {
      if (value !== '') {
        return value?.match(/(6|7|8|9)[ -]*([0-9][ -]*){8}$/) === null ? false : true
      }

      return true
    })
    .max(9, t(formTranslation.errors.maxChars, { value: 9 }))

export const mobilePhoneSchema = (
  t: TFunction<'translation', undefined>,
): StringSchema<string | undefined> =>
  stringSchema(t)
    .test('must-comply-format', t(formTranslation.errors.mobilePhoneInvalid), value => {
      if (value !== '') {
        return value?.match(/(6|7)[ -]*([0-9][ -]*){8}$/) === null ? false : true
      }

      return true
    })
    .max(9, t(formTranslation.errors.mobilePhoneInvalid, { value: 9 }))
